export const investorPages = [
  {
    id: 'executive-summary',
    title: 'Executive Summary',
    path: '/resources/Executive Summary 154c2137a84b8047a87ae006a156ca53.html'
  },
  {
    id: 'financial-summary',
    title: 'Financial Summary',
    path: '/resources/Projections Financial Summary 154c2137a84b804ca41ac004f37de21a.html'
  },
  {
    id: 'market-analysis',
    title: 'Market Analysis',
    path: '/resources/Strategy Market Analysis 154c2137a84b80fba4b0d9406b1c733b.html'
  },
  {
    id: 'growth-plan',
    title: 'Strategy / Growth Plan',
    path: '/resources/Strategy Growth Plan 154c2137a84b80f1a848d1ba5b28fd82.html'
  },
  {
    id: 'team',
    title: 'Team Bios',
    path: '/resources/Team Bios 154c2137a84b8080bd68f2c2527481aa.html'
  },
  {
    id: 'products',
    title: 'Products & Services',
    path: '/resources/Products & Services 154c2137a84b8076bb89df1e9a80a942.html'
  },
  {
    id: 'competition',
    title: 'Competitive Analysis',
    path: '/resources/Competitive Analysis 154c2137a84b80699d50f375c20eee74.html'
  },
  {
    id: 'case-study',
    title: 'Case Study',
    path: '/resources/Case Study 154c2137a84b808a84a5ffff8bea4ca5.html'
  },
  {
    id: 'roadmap',
    title: 'Roadmap',
    path: '/resources/Roadmap 154c2137a84b808c8c94e14cfae927c3.html'
  },
  {
    id: 'go-to-market',
    title: 'Go-To-Market Strategy',
    path: '/resources/Go-To-Market Strategy 154c2137a84b8005ae0ae7d4a8c418a4.html'
  },
  {
    id: 'swot',
    title: 'SWOT Analysis',
    path: '/resources/SWOT Analysis 154c2137a84b80f59232f6328d574573.html'
  },
  {
    id: 'faq',
    title: 'FAQ',
    path: '/resources/FAQ 18ac2137a84b80f5aeb1e523266cc86b.html'
  }
]; 